"use client";
import * as React from "react";
import { useMarketPicker } from "./market-picker-context";
export function RegionFallbackNotice({ rejected, current }: { rejected: string; current: string }) {
  const picker = useMarketPicker();
  const [dismissed, setDismissed] = React.useState(false);
  if (dismissed) return null;
  return <div role="region" aria-label="Pricing region changed" className="border-b border-border bg-surface-2 px-4 py-2 text-center text-xs">
    Your saved pricing region {rejected} is no longer available. Prices now use {current}. Your currency and delivery address are separate choices.{" "}
    <button className="underline" onClick={() => picker?.openPicker()}>Choose a market</button>{" "}
    <button className="underline" onClick={() => setDismissed(true)}>Dismiss</button>
  </div>;
}
